import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AviationEvent, AviationEventTypeDesc, AviationEventType } from '../../shared/models/aviation-event.model';
import * as moment from 'moment-timezone';
import { MatDialog, MatDialogConfig, MatDialogRef, MatSnackBar } from '@angular/material';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { EditEventLocationComponent } from '../edit-event-location/edit-event-location.component';
import { AviationEventsService } from '../../shared/services/aviation-events.service';


@Component({
  selector: 'app-event-details',
  templateUrl: './event-details.component.html',
  styleUrls: ['./event-details.component.scss']
})
export class EventDetailsComponent implements OnInit, OnChanges {
  @Input() aviationEvent: AviationEvent;
  @Output() dataChangedEvent = new EventEmitter<AviationEvent>();
  eventStart: moment;
  eventEnd: moment;
  eventStartDateString: string;
  eventStartTimeString: string;
  eventEndDateString: string;
  eventEndTimeString: string;
  editModeSet = false;
  aviationEventTypeDesc = AviationEventTypeDesc;
  aviationEventType = AviationEventType;

  constructor(private _editDescDialog: MatDialog,
              private _toggleService: EditToggleService,
              public snackBar: MatSnackBar,
              private _aviationEventsService: AviationEventsService) { }

  get contactWebAddress(): string {
    if (this.aviationEvent.webinarRegistrationLink.indexOf('http://') >= 0 ||
      this.aviationEvent.webinarRegistrationLink.indexOf('https://') >= 0) {
      return this.aviationEvent.webinarRegistrationLink;
    } else {
      return 'http://' + this.aviationEvent.webinarRegistrationLink;
    }
  }

  get informationWebAddress(): string {
    if (this.aviationEvent.informationWebsite.indexOf('http://') >= 0 ||
      this.aviationEvent.informationWebsite.indexOf('https://') >= 0) {
      return this.aviationEvent.informationWebsite;
    } else {
      return 'http://' + this.aviationEvent.informationWebsite;
    }
  }

  ngOnInit() {
    this._toggleService.toggleEmitter.subscribe(isOn => {
      this.editModeSet = isOn;
    });
    this.setDates();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setDates();
  }

  setDates() {
    this.eventStart = moment.tz(this.aviationEvent.startDateTime, 'UTC');
    this.eventStartDateString = this.eventStart.clone().tz(this.aviationEvent.timezone).format('dddd, MMMM Do, YYYY');
    this.eventStartTimeString = this.eventStart.clone().tz(this.aviationEvent.timezone).format('h:mm a z');
    this.eventEnd = moment.tz(this.aviationEvent.endDateTime, 'UTC');
    this.eventEndDateString = this.eventEnd.clone().tz(this.aviationEvent.timezone).format('dddd, MMMM Do, YYYY');
    this.eventEndTimeString = this.eventEnd.clone().tz(this.aviationEvent.timezone).format('h:mm a z');
  }

  async reloadEntity() {
    this.aviationEvent = await this._aviationEventsService.getAviationEventById(this.aviationEvent.eventId);
    this.setDates();
    this.dataChangedEvent.emit(this.aviationEvent);
  }

  openEditDetailsDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '800px';
    dialogConfig.data = {aviationEvent: this.aviationEvent};

    const DIALOG_REF = this._editDescDialog.open(EditEventLocationComponent, dialogConfig);
    this._handleModalClose(DIALOG_REF);
  }

  /**
   * listens for dialog close event. Opens snackbar if necessary
   * @param {MatDialogRef<any>} dialogRef
   * @private
   */
  _handleModalClose ( dialogRef: MatDialogRef<any>) {
    const ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';

    dialogRef.afterClosed().subscribe((success) => {
      if (success === null) { return; }
      if (success) {
        this.reloadEntity();
        this.snackBar.open('Event Details', 'Updated', {
          duration: 3000
        });
      } else {
        this.snackBar.open(ERROR_MSG, 'Error', {
          duration: 6000
        });
      }
    });
  }
}
